import type { AssociatedField } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/types/layout-items.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { JWMFieldDetails } from './__generated_apollo__/JWMFieldDetails';

export const toAssociatedField = (data: JWMFieldDetails): AssociatedField | undefined => {
	const fieldDetails = data?.jira?.jwmCustomFieldDetails;
	if (!fieldDetails) {
		return;
	}
	return {
		name: fieldDetails.name ?? '',
		key: fieldDetails.fieldId ?? '',
		externalUuid: fieldDetails.fieldId ?? '',
		type: fieldDetails.type ?? '',
		custom: true,
		global: false,
		description: fieldDetails.description ?? '',
		category: '',
		required: false,
		options: fieldDetails.options?.edges
			? fieldDetails.options.edges.map((edge) => ({
					id: +String(edge?.node?.optionId),
					optimisticId: String(edge?.node?.optionId),
					value: String(edge?.node?.value),
					externalUuid: String(edge?.node?.optionId),
					...(fieldDetails.type === 'com.atlassian.jira.plugin.system.customfieldtypes:select' &&
					expVal(
						'thor_colourful_single_select_milestone2_experiment',
						'isColorfulSingleSelectEnabled',
						false,
					)
						? { colour: edge?.node?.color?.colorKey }
						: {}),
				}))
			: undefined,
		configuration: fieldDetails.configuration,
		operations: {
			editable: fieldDetails.operations?.editable ?? false,
			deletable: fieldDetails.operations?.deletable ?? false,
			removable: fieldDetails.operations?.removable ?? false,
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			categoriesWhitelist: (fieldDetails.operations?.categoriesWhitelist as string[]) ?? [],
			canAssociateInSettings: fieldDetails.operations?.canAssociateInSettings ?? false,
			canModifyOptions: fieldDetails.operations?.canModifyOptions ?? false,
			canModifyDefaultValue: false,
			canModifyPropertyConfiguration:
				fieldDetails.operations?.canModifyPropertyConfiguration ?? false,
			canModifyRequired: fieldDetails.operations?.canModifyRequired ?? false,
		},
		availability: null,
	};
};
